import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { useFlags } from "@/lib/flags";
import { Button } from "@/components/ui/button";
import { owedLine, minus } from "@/lib/documents";
import { Wallet } from "lucide-react";

// design_handoff_founder_assistant screen 9, "Ran on credit": a paid plan's scheduled investor update ran with no credits
// left, so the company owes it until its next credits cover it (backend doc_schedules.owed). On Documents (its list
// carries the amount) and the Overview (which asks for it).
export function OwedBanner({ owed }) {
  if (!(owed > 0)) return null;
  const [before, after] = owedLine(owed).split(minus(owed));
  return (
    <div role="status" className="flex flex-wrap items-center gap-3 px-4 py-3 rounded-[10px] border border-gr-warning" data-testid="owed-banner">
      <Wallet className="w-4 h-4 shrink-0 text-gr-warning" aria-hidden="true" />
      <span className="flex-1 min-w-[220px] [text-wrap:pretty]">{before}<span className="font-semibold text-gr-warning tabular-nums">{minus(owed)}</span>{after}</span>
      <Button asChild><Link to="/founder/store#topup">Add credits</Link></Button>
    </div>
  );
}

export default function OverviewOwed() {
  const flags = useFlags();
  const on = !!(flags.documents && flags.store);
  const { data } = useQuery({ queryKey: ["documents-owed"], enabled: on, refetchInterval: 60000,
                              queryFn: async () => (await api.get("/documents/owed")).data });
  return on ? <OwedBanner owed={data?.owed_usd} /> : null;
}
